import { FinancePartnerDetails } from "../@types/types";
import bearerAxios from "../helpers/bearerAxios";
import {logger} from "./loggingService";

const DEFAULT_ERROR_MESSAGE = 'ACAD Template Generation Failed';

const getErrorMessage = async (error: unknown): Promise<string> => {
    const response = (error as { response?: { data?: unknown; status?: number; statusText?: string } })?.response;
    const data = response?.data;

    const fromProblemDetails = (parsed: { title?: string; detail?: string; message?: string; status?: number }) => {
        const title = parsed.detail || parsed.title || parsed.message;
        if (!title) {
            return '';
        }
        const status = parsed.status ?? response?.status;
        return status ? `${status} ${title}` : title;
    };

    if (data instanceof Blob) {
        try {
            return fromProblemDetails(JSON.parse(await data.text())) || DEFAULT_ERROR_MESSAGE;
        } catch {
            return response?.statusText || DEFAULT_ERROR_MESSAGE;
        }
    }

    if (data && typeof data === 'object') {
        return fromProblemDetails(data) || DEFAULT_ERROR_MESSAGE;
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return DEFAULT_ERROR_MESSAGE;
};

const getACADExcelFile = async (opId: string, designId: string, financePartnerDetails: FinancePartnerDetails | null) => {
    const { name, purchaseMethod } = financePartnerDetails || {};
    const queryParams = new URLSearchParams({
        opportunityId: opId,
        designId,
        financePartner: name ?? 'Good Leap',
        purchaseMethod: purchaseMethod ?? '',
    });
    try {
        const response = await bearerAxios.post(
            import.meta.env.VITE_BASE_URL +
            import.meta.env.VITE_GET_ACAD_FILE! +
            `?${queryParams.toString()}`,
            null,
            {
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        logger.error(error);
        throw new Error(await getErrorMessage(error));
    }
};


export {getACADExcelFile};
